import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/** Fix shared links that accidentally doubled the /soccer prefix */
const DuplicateSoccerRedirect = () => {
  const { pathname, search } = useLocation();
  const fixed = pathname.replace(/^\/soccer\/soccer/, '/soccer');
  return <Navigate to={`${fixed}${search}`} replace />;
};

export default DuplicateSoccerRedirect;
